namespace SorAraBul.PropertyManagement {

    @Serenity.Decorators.registerFormatter()
    export class SorsReportUrlFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext): string {
            const url = Q.trimToNull(ctx.value);
            if (!url)
                return "";

            const href = Q.attrEncode(url);
            return `<div class="sors-report-cell"><a href="${href}" target="_blank" rel="noopener noreferrer" class="sors-report-link" title="Sors raporunu aç"><i class="fa fa-file-text-o"></i><span>Rapor</span></a></div>`;
        }
    }
}
